

jQuery(document).ready(function($){

    
    if ($(window).width() <= 767) {
      setTimeout(function() {
        $(".custSingleProductBnr slider-component .slider-buttons--dots").removeClass("small-hide");
      }, 500);
    }
    $('.custProSecWthVdoBtmRt p').each(function() {
      if ($(this).text().trim() === '') {
        $(this).remove();
      }
    });
    $('.custHomeSec5 ul.multicolumn-list').slick({
        autoplay: false,
        autoplaySpeed: 2000,
        dots: true,
        arrows: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1
    });
	
	//if ($(window).width() <= 767) {
		/*$('.custHomeSec2 ul.icon-bar-slider').slick({
			autoplay: true,
			autoplaySpeed: 2000,
			dots: false,
			arrows: false,
			infinite: true,
			slidesToShow: 4,
			slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3
                    }
                }
            ]
		});*/
        /*$('.custHomeSec2 ul.icon-bar-slider').slick({
          autoplay: true,
          autoplaySpeed: 0,     
          speed: 10000,         
          cssEase: 'linear', 
          dots: false,
          arrows: false,
          infinite: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          pauseOnHover: false,
          pauseOnFocus: false,
          responsive: [
              {
                  breakpoint: 767,
                  settings: {
                      slidesToShow: 3
                  }
              }
          ]
      });*/
  /*
      var $slider = $('.custHomeSec2 ul.icon-bar-slider-');
    
      $slider.append($slider.html());
    
      $slider.slick({
        autoplay: true,
        autoplaySpeed: 0,
        speed: 10000, // or longer
        cssEase: 'linear',
        infinite: true,
        arrows: false,
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        pauseOnHover: false,
        pauseOnFocus: false,
        variableWidth: true, // makes it feel natural if items are flexible
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 3
            }
          }
        ]
      });
      */
/******/
var $slider = $(".custHomeSec2 ul.icon-bar-slider");
  
  // Clone the entire <ul> and append it below the original <ul>
  var $clone = $slider.clone();
  $slider.after($clone); 
/******/

  $('.custHomeSec5 slider-component ul li.slick-slide').each(function() {
        var stars = $(this).find('.testimonial-card__stars'); 
        var heading = $(this).find('.multicolumn-card__info h3');
        var authorContainer = $(this).find('.testimonial-card__author-container');

        if (authorContainer.length) {
            var newDiv = $('<div class="custAvtrInfo"></div>');
            newDiv.append(stars).append(heading);
            authorContainer.append(newDiv);
        }
  });

setTimeout(function () {
	$('.custClm2').appendTo('.custClm1');
	$('.custClm6').appendTo('.custClm5');
	
	$("<div class='custBtmFtr'></div>").appendTo("footer");
	$('.custClm7').appendTo('.custBtmFtr');
	
}, 500); 
    $(".custSingleProductTabs").appendTo(".custAppendedFaqs");

    let path = window.location.pathname;
    let pageName = path.split("/").filter(Boolean).pop();
    if (!pageName) {
      pageName = "home";
    }
    $("body").addClass("cust_" + pageName);

    if ($("#MainContent").length) {
      // Check if both elements exist
      if (
        $("#shopify-section-template--23916218810733__cart-items").length &&
        $("#shopify-section-template--23916218810733__cart-footer").length
      ) {
        // Create a new wrapper div
        let wrapper = $('<div class="custMainCart"></div>');
  
        // Append both elements inside the wrapper
        $("#shopify-section-template--23916218810733__cart-items").appendTo(wrapper);
        $("#shopify-section-template--23916218810733__cart-footer").appendTo(wrapper);
  
        // Append the wrapper inside #MainContent
        $("#MainContent").append(wrapper);
      }
    }

    var newDiv2 = $('<div class="custContactPageSec1"></div>');
    newDiv2.append($('#shopify-section-template--23916219203949__form'));
    newDiv2.append($('#shopify-section-template--23916219203949__ds_icon_bar_gQwzDP'));
    $('.cust_contact .custInrBnr.custAllInrBnrMn').after(newDiv2);  
	
	/**/
	$(document).on("DOMNodeInserted", ".jdgm-rev.jdgm-divider-top.jdgm--done-setup", function() {
		setTimeout(() => {
			$(this).find(".jdgm-rev__header").prependTo($(this).find(".jdgm-rev__content"));
		}, 500);
	});



 setInterval(function () {
        $(".jdgm-rev__pic-img").each(function () {
            let imgSrc = $(this).attr("src");
            let dataSrc = $(this).attr("data-src");

            if (imgSrc && imgSrc.includes("?")) {
                let cleanSrc = imgSrc.split("?")[0];
                $(this).attr("src", cleanSrc);
            }

            if (dataSrc && dataSrc.includes("?")) {
                let cleanDataSrc = dataSrc.split("?")[0];
                $(this).attr("data-src", cleanDataSrc);
            }
        });
       $("#product-grid .card__media img").each(function () {
            let imgSrc = $(this).attr("src");
            let dataSrc = $(this).attr("data-src");

            if (imgSrc && imgSrc.includes("?")) {
                let cleanSrc = imgSrc.split("?")[0];
                $(this).attr("src", cleanSrc);
            }

            if (dataSrc && dataSrc.includes("?")) {
                let cleanDataSrc = dataSrc.split("?")[0];
                $(this).attr("data-src", cleanDataSrc);
            }
        });
    }, 200);


  document.querySelectorAll('.custBtmFtr li.list-social__item a').forEach(function(link) {
    link.setAttribute('target', '_blank');
  });


});


jQuery(document).ready(function($){	
	$('.grid__item.product__media-wrapper').append($('.code-brand-single-review'));
});

